import * as types from '../../constants/index'
export default {
  state: {
    alertStatus: false,
    courseManageStatus: false
  },
  actions: {},
  mutations: {
    [types.ALERT_STATUS](state, payload) {
      state.alertStatus = payload
    },
    [types.COURSE_MANAGE_STATUS](state, payload) {
      state.courseManageStatus = payload
    }
  },
  getters: {
    alertStatus: state => state.alertStatus,
    courseManageStatus: state => state.courseManageStatus
  }
}
